import React from "react";
import { GrcCard, effectiveScore, effectiveRag, pillarsArray, priorityFor, ragColor, isWorkflowPillar } from "./shared";

export const PillarHeatmap = ({ pillars, sdf, onPillarClick }) => {
  const arr = pillarsArray(pillars);
  return (
    <GrcCard
      title="Pillar RAG Heatmap"
      info="Per-pillar score, RAG status and remediation priority window. Click a row for detail. P9 shows SDF Module B score."
      infoTestId="info-pillar-heatmap"
      testId="widget-pillar-heatmap"
      className="lg:col-span-5"
    >
      <div className="overflow-x-auto -mx-2">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 text-slate-500">
            <tr className="text-left">
              <th className="px-2 py-1.5 font-medium">Code</th>
              <th className="px-2 py-1.5 font-medium">Pillar</th>
              <th className="px-2 py-1.5 font-medium text-right">Score %</th>
              <th className="px-2 py-1.5 font-medium">RAG</th>
              <th className="px-2 py-1.5 font-medium whitespace-nowrap">Priority / Timeline</th>
            </tr>
          </thead>
          <tbody>
            {arr.map((p) => {
              const score = effectiveScore(p, sdf);
              const rag = effectiveRag(p, sdf);
              return (
                <tr
                  key={p.code}
                  data-testid={`heatmap-row-${p.code}`}
                  onClick={() => onPillarClick?.(p.code)}
                  className="border-b border-slate-100 last:border-0 hover:bg-blue-50/60 cursor-pointer transition-colors"
                >
                  <td className="px-2 py-1.5 font-mono font-semibold text-[#003366]">{p.code}</td>
                  <td className="px-2 py-1.5 text-slate-700">
                    <span className="inline-flex items-center gap-1.5">
                      <span>{p.name}</span>
                      {isWorkflowPillar(p.code) && (
                        <span
                          data-testid={`workflow-badge-${p.code}`}
                          title="Non-scoring workflow pillar"
                          className="inline-flex items-center rounded-full bg-[#008080]/10 text-[#008080] text-[9px] font-semibold uppercase tracking-wider px-1.5 py-0.5 border border-[#008080]/20"
                        >
                          Workflow
                        </span>
                      )}
                    </span>
                  </td>
                  <td className="px-2 py-1.5 text-right font-semibold text-[#003366] whitespace-nowrap">
                    {score != null ? `${score}%` : "—"}
                  </td>
                  <td className="px-2 py-1.5">
                    <span className="inline-flex items-center gap-1.5 font-medium" style={{ color: ragColor(rag) }}>
                      <span className="w-2 h-2 rounded-full" style={{ backgroundColor: ragColor(rag) }} />
                      {rag}
                    </span>
                  </td>
                  <td className="px-2 py-1.5 text-slate-600">{priorityFor({ ...p, rag })}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="mt-2 text-center text-[11px] text-slate-400" data-testid="heatmap-scroll-hint">
        Showing all {arr.length} pillars · P9/P10/P11 are non-scoring workflow pillars
      </div>
    </GrcCard>
  );
};
